import type { ReactNode } from 'react';

/**
 * A compact breadcrumb-style action. Renders alongside the breadcrumb at the
 * top of the page, not inside the card body — so it is small and primary,
 * not a big bordered button. Uses the accent token pair (`bg-accent` /
 * `text-accent-content`) so it reads as the page's primary call-to-action.
 */
export function SuspendButton({
  disabled,
  onSuspend,
}: {
  disabled: boolean;
  onSuspend: () => void;
}): ReactNode {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onSuspend}
      className="inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md bg-accent px-3 text-sm font-semibold text-accent-content transition-colors hover:bg-accent/90 disabled:opacity-50"
    >
      {disabled ? 'Suspending…' : 'Suspend'}
    </button>
  );
}
